import { _locale } from '../WiseEcom/services/WiseLocale'
import { wiseAlert } from '../WiseEcom/services/WiseAlert'
import store from '../store'
import WiseSettings from '../WiseSettings'

let firstLoad = true

function sessionRejectionAlert() {
    console.log(`%cAccess token unvalid, user need to re-login`, 'color: yellow; padding: 5px 0')
    wiseAlert({
        mode: 'ios',
        backdropDismiss: false,
        message: _locale('login.sessionExpired'),
        buttons: ['OK']
    })    
}

export async function defaultGuard(to, from, next) {
    const redirect = WiseSettings?.defaultPath?.redirect || '/'
    const rejection = async () => {
        // main.js triggers one round of router logic before App.vue is ready
        // and this might lead to a timing issue against WebView on native platforms
        // when IonAlert/IonModal is called..
        if (firstLoad) {
            firstLoad = false
        } else {
            sessionRejectionAlert()
        }
        
        // requestAnimationFrame or setTimeout might work here but not sure...
        //requestAnimationFrame(() => sessionRejectionAlert())
        
        // reset all states before trying to log back in
        await store.dispatch('user/logOut')
            .catch(e => console.log(e))
        
        next(redirect)
    }

    try {
        // User is logged in, validate accessToken
        const accessTokenValid = await store.dispatch('user/validateAccessTokenFromStorage')
        
        if (accessTokenValid === false) {
            await rejection()
        }
    } catch {
        await rejection()
    }
    
    // All good, user can access route
    next()
}